<template>
  <div class="params-detail v2-waterParameter">
    <div class="v2-waterP-content" style="width:98%;margin:35px auto">
      <!-- <el-input class="power" v-model="name" placeholder="车间名称" ></el-input> -->
      <el-select
        v-model="paramerName"
        slot="prepend"
        placeholder=""
        @change="selectParamer"
      >
        <el-option
          v-for="(item,index) in this.parameterList"
          :key="index"
          :label="item.name"
          :value="String(item.iotName)"
        ></el-option>

      </el-select>
      <span class="demonstration">时间</span>
      <el-date-picker
        v-model="start"
        :clearable="false"
        type="datetime"
        format="yyyy-MM-dd"
        :picker-options="pickerTimeOptions"
        placeholder="开始日期"
      >
      </el-date-picker>
      <span class="spr-line"></span>
      <el-date-picker
        v-model="end"
        type="datetime"
        :clearable="false"
         format="yyyy-MM-dd"
        :picker-options="pickerTimeOptions"
        placeholder="结束日期"
      >
      </el-date-picker>
      <el-button
        type="primary"
        @click="search"
      >查询</el-button>
      <el-button @click="exportImage" type="success" >导出图片</el-button>
      <el-button @click="exportData" type="success" >导出表格</el-button>
    </div>
    <div class="v2-radio-group" style="">
      <div class="selecter-one" v-if="this.date !== '一天内'">
        <el-radio-group v-model="showMode" size="small" @change="search">
          <el-radio-button label="每日单独展示" value="每日单独展示">每日单独展示</el-radio-button>
          <el-radio-button label="合并展示" value="合并展示">合并展示</el-radio-button>
        </el-radio-group>
      </div>
      <div class="selecter-tow">
        <el-radio-group v-model="date" size="small"  @change="changeRadio()">
          <el-radio-button
            v-for="(item, index) in dateList"
              :key="index"
              :label="item.name"
              :value="item.name">
              {{item.name}}
          </el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div
      ref="waterParameter"
      id="waterParameter"
      class="waterParameter"
      style="height:70vh;width:98%;margin:25px auto"
    >
    </div>
    <div
      v-if="show"
      class="nodata"
    >
      <img
        src="../../assets/icon_data_empty.png"
        alt=""
      >
      <span>该条件下暂无数据</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import equipmentV2 from '../../store/modules/equipmentV2'
import parameterV2 from '../../store/modules/parameterV2'
import { mapState, mapActions, mapMutations } from 'vuex'
import echarts from 'echarts'
let date = new Date(new Date(new Date().toLocaleDateString()).getTime())
let endDate = new Date(
  new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
)
let today = new Date()
today.setHours(0)
today.setMinutes(0)
today.setSeconds(0)
today.setMilliseconds(0)
let oneday = 1000 * 60 * 60 * 24
let threeDay = 1000 * 60 * 60 * 24 * 2
let fourDay = 1000 * 60 * 60 * 24 * 3
let fiveDay = 1000 * 60 * 60 * 24 * 4

export default {
  name: 'waterParameter',

  data () {
    return {
      dateList: [
        {
          id: 1,
          name: '一天内'
        },
        {
          id: 2,
          name: '两天内'
        },
        {
          id: 3,
          name: '三天内'
        },
        {
          id: 4,
          name: '四天内'
        },
        {
          id: 5,
          name: '五天内'
        }
      ],
      date: '一天内',
      show: false,
      paramerName: this.$route.query.iotName != null ? String(this.$route.query.iotName) : '',
      // name: '一号车间',
      start: date,
      end: endDate,
      // 限制日期
      pickerTimeOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      value: '',
      parameList: [],
      dataList: [],
      iotId: '',
      pond: '',
      equData: '',
      parameterList: [],
      seriesData: [],
      nameList: [],
      xData: [],
      reorganizationData: [],
      dataObj: [],
      equId: this.$route.query.equId,
      paramerName1: '',
      showMode: '每日单独展示'
    }
  },
  watch: {
    equipmentData: {
      handler (value) {
        this.bindParameterList()
        if (this.seriesData && this.seriesData.length) {
          this.tempauure()
        }
      }
    },
    date (date) {
      // console.log('date', date)
      this.getLineData(date)
    },
    start (startDate) {
      if (this.date === '一天内') {
        this.start = this.$timeformat(new Date(new Date(startDate).toLocaleDateString()).getTime())// 00:00:00
        let a = new Date(startDate).getTime()
        this.end = this.$timeformat(new Date(new Date(a).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)// 23:59分59秒

        // console.log('哈哈哈',
        //   this.$timeformat(new Date(new Date(this.end).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1))
      }
      if (this.date === '两天内') {
        this.start = this.$timeformat(new Date(new Date(startDate).toLocaleDateString()).getTime())// 00:00:00
        let a = new Date(startDate).getTime()
        this.end = new Date(new Date(a).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1 + 24 * 3600 * 1000
      }
      if (this.date === '三天内') {
        this.start = this.$timeformat(new Date(new Date(startDate).toLocaleDateString()).getTime())// 00:00:00
        let a = new Date(startDate).getTime()
        this.end = new Date(new Date(a).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1 + 2 * 24 * 3600 * 1000
      }
      if (this.date === '四天内') {
        this.start = this.$timeformat(new Date(new Date(startDate).toLocaleDateString()).getTime())// 00:00:00
        let a = new Date(startDate).getTime()
        this.end = new Date(new Date(a).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1 + 3 * 24 * 3600 * 1000
      }
      if (this.date === '五天内') {
        this.start = this.$timeformat(new Date(new Date(startDate).toLocaleDateString()).getTime())// 00:00:00
        let a = new Date(startDate).getTime()
        this.end = new Date(new Date(a).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1 + 4 * 24 * 3600 * 1000
      }
    },
    end (endDate) {
      if (this.date === '一天内') {
        this.end = this.$timeformat(endDate)
        let a = new Date(endDate).getTime()
        this.start = a
      }
      if (this.date === '两天内') {
        this.end = this.$timeformat(endDate)
        let a = new Date(endDate).getTime()
        this.start = a - 1 * 24 * 3600 * 1000
      }
      if (this.date === '三天内') {
        this.end = this.$timeformat(endDate)
        let a = new Date(endDate).getTime()
        this.start = a - 2 * 24 * 3600 * 1000
      }
      if (this.date === '四天内') {
        this.end = this.$timeformat(endDate)
        let a = new Date(endDate).getTime()
        this.start = a - 3 * 24 * 3600 * 1000
      }
      if (this.date === '五天内') {
        this.end = this.$timeformat(endDate)
        let a = new Date(endDate).getTime()
        this.start = a - 4 * 24 * 3600 * 1000
      }
    },
    basic (val) {
      console.log(this.paramerName1)

      this.setActiveTitle('')
      this.setActiveTitle(val.title + '' + this.$route.query.equName + '' + this.$route.query.paraName + '曲线')
    }
  },
  async mounted () {
    // 大屏首页会把 html 根字号改成 rem，离开时若不还原，本页按钮文字会被裁切
    document.documentElement.style.fontSize = ''
    window.onresize = null
    // this.setActiveTitle('')
    // this.setActiveTitle(this.basic.title + '' + this.$route.query.equName + '' + this.$route.query.paraName + '曲线')
    if (this.$route.query.iotName != null && this.$route.query.iotName !== '') {
      this.paramerName = String(this.$route.query.iotName)
    }
    await this.ensureEquipmentData()
    this.bindParameterList()
    if (this.$route.query.equId) {
      this.search()
    }
  },
  computed: {
    ...mapState(equipmentV2, ['equipmentData', 'activeTitle', 'basic'])
  },

  methods: {
    ...mapMutations(equipmentV2, ['setActiveTitle']),
    ...mapActions(parameterV2, ['getParamerLine']),
    ...mapActions(equipmentV2, ['getEquipmentsData']),
    changeRadio (item) {
      console.log()
    },
    bindParameterList () {
      const eqs = (this.equipmentData && this.equipmentData.sensorEquipments) || []
      const equId = this.$route.query.equId || this.equId
      this.equData = eqs.find(f => String(f.id) === String(equId))
      if (!this.equData && this.paramerName != null && String(this.paramerName) !== '') {
        this.equData = eqs.find(eq => (eq.sensors || []).some(s => String(s.iotName) === String(this.paramerName)))
      }
      if (!this.equData && this.$route.query.paraName) {
        this.equData = eqs.find(eq => (eq.sensors || []).some(s => s.name === this.$route.query.paraName))
      }
      this.parameterList = this.equData ? this.equData.sensors : []
    },
    async ensureEquipmentData () {
      const eqs = (this.equipmentData && this.equipmentData.sensorEquipments) || []
      if (eqs.length) {
        return
      }
      let obj = null
      try {
        obj = JSON.parse(localStorage.getItem('currentBasic') || 'null')
      } catch (e) {
        obj = null
      }
      if (!obj) {
        return
      }
      await this.getEquipmentsData(obj)
    },
    getCurrentParam () {
      const eqs = (this.equipmentData && this.equipmentData.sensorEquipments) || []
      let list = (this.parameterList && this.parameterList.length) ? this.parameterList : []
      if (!list.length) {
        const equ = eqs.find(f => String(f.id) === String(this.$route.query.equId || this.equId))
        if (equ && equ.sensors) {
          list = equ.sensors
        } else {
          eqs.forEach(eq => {
            if (eq.sensors && eq.sensors.length) {
              list = list.concat(eq.sensors)
            }
          })
        }
      }
      if (!list.length) {
        return null
      }
      if (this.paramerName != null && String(this.paramerName) !== '') {
        const byIot = list.find(f => String(f.iotName) === String(this.paramerName))
        if (byIot) {
          return byIot
        }
      }
      if (this.$route.query.paraName) {
        return list.find(f => f.name === this.$route.query.paraName) || null
      }
      return null
    },
    // Y 轴：min = 数据最小值 * 0.9（>1 保留 1 位小数，<1 保留 2 位小数）；
    // max = 数据最大值 * 1.1（>1 保留 1 位小数，(0,1) 保留 2 位小数；数据最大值为 0 时取 1）
    formatYAxisMin (value) {
      if (value > 1) {
        return Math.round(value * 10) / 10
      }
      if (value < 1) {
        return Math.round(value * 100) / 100
      }
      return value
    },
    formatYAxisMax (value) {
      if (value > 1) {
        return Math.round(value * 10) / 10
      }
      if (value > 0 && value < 1) {
        return Math.round(value * 100) / 100
      }
      return value
    },
    getYAxisRange () {
      const values = []
      ;(this.seriesData || []).forEach(series => {
        ;(series.data || []).forEach(item => {
          const num = Array.isArray(item) ? Number(item[1]) : Number(item)
          if (!isNaN(num) && item !== null && item !== undefined && item !== '') {
            values.push(num)
          }
        })
      })
      if (!values.length) {
        return null
      }
      const dataMin = Math.min.apply(null, values)
      const dataMax = Math.max.apply(null, values)
      return {
        min: this.formatYAxisMin(dataMin * 0.9),
        max: dataMax === 0 ? 1 : this.formatYAxisMax(dataMax * 1.1)
      }
    },
    // 导出数据
    exportData () {
      console.log(this.paramerName)
      let title = this.parameterList[this.paramerName].name
      axios({
        method: 'GET',
        url: `/api/Equipment/ExportSensorHistoryData`,
        params: {
          id: this.equId,
          iotName: this.paramerName,
          dStart: this.$timeformat(this.start),
          dEnd: this.$timeformat(this.end)
        },
        responseType: 'blob'
      }).then(data => {
        /* 兼容ie内核，360浏览器的兼容模式 */
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          let blob = new Blob([data.data])
          // window.navigator.msSaveOrOpenBlob(blob, "称重单明细.xls");
          console.log(blob)
          window.navigator.msSaveOrOpenBlob(blob, `${title}记录.xls`)
        } else {
          /* 火狐谷歌的文件下载方式 */
          var blob = new Blob([data.data])
          var downloadElement = document.createElement('a')
          var href = window.URL.createObjectURL(blob)
          downloadElement.href = href
          // downloadElement.download = "称重单明细.xls";
          downloadElement.download = `${title}记录.xls`

          document.body.appendChild(downloadElement)
          downloadElement.click()
          document.body.removeChild(downloadElement)
          window.URL.revokeObjectURL(href)
        }
      })
    },
    // 导出数据
    exportImage () {
      var dom = document.getElementById('waterParameter')
      var myChart = echarts.init(dom)
      myChart.setOption({
        backgroundColor: 'rgba(27, 34, 49, 1)' }) // 背景色
      this.saveAsImage(myChart)
      myChart.setOption({
        backgroundColor: 'rgba(175,201,255,.1)' })
    },
    base64ToBlob (code) {
      let parts = code.split(';base64,')
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length

      let uInt8Array = new Uint8Array(rawLength)

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], { type: contentType })
    },
    saveAsImage (myChart) {
      let content = myChart.getDataURL()

      let aLink = document.createElement('a')
      let blob = this.base64ToBlob(content)

      let evt = document.createEvent('HTMLEvents')
      evt.initEvent('click', true, true)
      aLink.download = 'line.png'
      aLink.href = URL.createObjectURL(blob)
      aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }))
    },
    getLineData (date) {
      if (date === '一天内') {
        this.start = today
        this.end = endDate
        this.selectParamer(this.paramerName)
      }
      if (date === '两天内') {
        this.start = new Date(today - oneday)
        this.end = endDate
        this.selectParamer(this.paramerName)
      }
      if (date === '三天内') {
        this.start = new Date(today - threeDay)
        this.end = endDate
        this.selectParamer(this.paramerName)
      }
      if (date === '四天内') {
        this.start = new Date(today - fourDay)
        this.end = endDate
        this.selectParamer(this.paramerName)
      }
      if (date === '五天内') {
        this.start = new Date(today - fiveDay)
        this.end = endDate
        this.selectParamer(this.paramerName)
      }
    },
    // 切换参数
    selectParamer (value) {
      let data = this.parameterList.find(f => String(f.iotName) === String(value))
      this.paramerName1 = data.name
      this.setActiveTitle('')
      this.setActiveTitle(this.basic.title + '' + this.$route.query.equName + '' + this.paramerName1 + '曲线')
      this.getParamerLine({
        id: this.equId,
        iotName: value,
        dStart: this.$timeformat(this.start),
        dEnd: this.$timeformat(this.end) }
      ).then((rsp) => {
        this.dataObj = rsp
        if (this.dataObj.length !== 0) {
          // 新格式化逻辑
          this.nameList = this.arrayName(this.dataObj)
          this.initChartData()

          // 旧格式化逻辑 Start
          // this.reorganizationData = this.arrayReorganization(this.dataObj)
          // this.nameList = this.arrayName(this.dataObj)
          // this.getSeriesData(this.nameList)
          // this.getMultiXData(this.reorganizationData)
          // this.findDotByName()
          // 旧格式化逻辑 End

          this.show = false
        } else {
          this.dataList = []
          this.xData = []
          this.seriesData = []
          this.show = true
        }
        this.tempauure()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 查询
    search () {
      this.getParamerLine({
        id: this.equId,
        iotName: this.paramerName,
        dStart: this.$timeformat(this.start),
        dEnd: this.$timeformat(this.end) }
      ).then((rsp) => {
        this.dataObj = rsp
        if (this.dataObj.length !== 0) {
          // 新格式化逻辑
          this.nameList = this.arrayName(this.dataObj)
          this.initChartData()

          // 旧格式化逻辑 Start
          // this.reorganizationData = this.arrayReorganization(this.dataObj)
          // this.nameList = this.arrayName(this.dataObj)
          // this.getSeriesData(this.nameList)
          // this.getMultiXData(this.reorganizationData)
          // this.findDotByName()
          // 旧格式化逻辑 End

          this.show = false
        } else {
          this.dataList = []
          this.xData = []
          this.seriesData = []
          this.show = true
        }
        this.tempauure()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取 xdata
    getMultiXData (array) {
      this.xData = []
      array.forEach((element) => {
        this.xData.push(element.name)
      })
    },
    // 按时间分组
    arrayReorganization (array) {
      let arr = []
      let obj = {}
      let index = 0
      array.forEach((element) => {
        if (obj.hasOwnProperty(element.moment)) {
          arr[obj[element.moment]].item.push(element)
        } else {
          obj[element.moment] = index++
          arr.push({
            name: element.moment,
            item: [element]
          })
        }
      })
      return arr
    },
    // 按姓名分组
    arrayName (array) {
      let arr = []
      let obj = {}
      let index = 0
      array.forEach((element) => {
        if (obj.hasOwnProperty(element.date)) {
          arr[obj[element.date]].item.push(element)
        } else {
          obj[element.date] = index++
          arr.push({
            name: element.date,
            item: [element]
          })
        }
      })
      arr = arr.sort((a, b) => {
        return new Date(a.name).getTime() - new Date(b.name).getTime()
      })
      return arr
    },
    // 根据名字找时间的点
    findDotByName () {
      let obj = []
      for (let i = 0; i < this.nameList.length; i++) {
        obj[i] = []
      }
      for (let i = 0; i < this.nameList.length; i++) {
        this.reorganizationData.forEach((element) => {
          let findObj = element.item.find((m) => {
            if (this.nameList[i].name === m.date) {
              return true
            }
          })
          if (findObj) {
            obj[i].push(findObj.value)
          } else {
            obj[i].push(0)
          }
        })
      }
      return obj
    },
    // 获取多渔种趋势曲线图
    getSeriesData (array) {
      if (this.date === '一天内') {
        this.seriesData = []
        let len = array.length
        for (let i = 0, size = len; i < size; i++) {
          this.seriesData.push({
            name: this.nameList[i].name,
            type: 'line',
            smooth: true,
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 1,
                    color: 'rgba(120,198,255,0.1)'
                  },
                  {
                    offset: 0,
                    color: 'rgba(4,150,255,1)'
                  }
                ])
              }
            },
            data: this.findDotByName()[i],
            seriesLayoutBy: 'row',
            symbol: 'none',
            symbolSize: 0,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2.5
                }
              }
            }
          })
        }
      } else {
        this.seriesData = []
        let len = array.length
        for (let i = 0, size = len; i < size; i++) {
          this.seriesData.push({
            name: this.nameList[i].name,
            type: 'line',
            smooth: true,
            data: this.findDotByName()[i],
            seriesLayoutBy: 'row',
            symbol: 'circle',
            symbolSize: 0,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2.5
                }
              }
            }
          })
        }
      }
    },

    tempauure (e) {
      const chartDom = this.$refs.waterParameter
      if (!chartDom) {
        return
      }
      if (typeof this.$echarts.dispose === 'function') {
        this.$echarts.dispose(chartDom)
      }
      const myChart = this.$echarts.init(chartDom)
      const yRange = this.getYAxisRange()
      const yAxis = {
        type: 'value',
        scale: yRange == null,
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          formatter: '{value}',
          textStyle: {
            color: '#BBD4E9'
          }
        },
        axisLine: {
          lineStyle: {
            color: '#07f',
            width: 1
          }
        }
      }
      if (yRange != null) {
        yAxis.min = yRange.min
        yAxis.max = yRange.max
        yAxis.scale = false
      }

      myChart.setOption({
        backgroundColor: 'rgba(175,201,255,.1)',
        grid: {
          top: '14%',
          bottom: '12%',
          left: 50,
          right: 20,
          x: 80,
          y: 45,
          x2: 40,
          y2: 50,
          borderWidth: 1
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            align: 'left'
          }
        },
        legend: {
          tooltip: {
            trigger: 'item',
            show: true
          },
          itemGap: 30,
          bottom: '3%',
          icon: 'circle',
          itemWidth: 6,
          itemHeight: 6,
          textStyle: {
            color: 'rgba(255,255,255,1)',
            fontSize: 14,
            fontFamily: 'Microsoft YaHei'
          },
          x: 'center',
          data: this.nameList
        },
        color: ['#93C6FF', '#8F64FC', '#FF5898', '#FFCD57', '#3D5AFE', '#6ADAEE', '#00D478'],
        xAxis: {
          type: 'category',
          data: this.xData,
          splitLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#BBD4E9'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#07f',
              width: 1
            }
          }
        },
        yAxis: yAxis,
        series: this.seriesData
      }, true)
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
    // 格式化图表数据
    initChartData () {
      // 一天内 return
      if (this.date === '一天内') {
        this.xData = this.dataObj.map(item => item.moment)

        this.seriesData = [{
          name: this.nameList[0].name,
          type: 'line',
          smooth: true,
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: 'rgba(120,198,255,0.1)'
                },
                {
                  offset: 0,
                  color: 'rgba(4,150,255,1)'
                }
              ])
            }
          },
          data: this.dataObj.map(item => item.value),
          seriesLayoutBy: 'row',
          symbol: 'none',
          symbolSize: 0,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 2.5
              }
            }
          }
        }]
        return
      }
      // 每日单独展示 return
      if (this.showMode === '每日单独展示') {
        this.xData = ['00:00', '00:20', '00:40', '01:00', '01:20', '01:40', '02:00', '02:20', '02:40', '03:00', '03:20', '03:40', '04:00', '04:20', '04:40', '05:00', '05:20', '05:40', '06:00', '06:20', '06:40', '07:00', '07:20', '07:40', '08:00', '08:20', '08:40', '09:00', '09:20', '09:40', '10:00', '10:20', '10:40', '11:00', '11:20', '11:40', '12:00', '12:20', '12:40', '13:00', '13:20', '13:40', '14:00', '14:20', '14:40', '15:00', '15:20', '15:40', '16:00', '16:20', '16:40', '17:00', '17:20', '17:40', '18:00', '18:20', '18:40', '19:00', '19:20', '19:40', '20:00', '20:20', '20:40', '21:00', '21:20', '21:40', '22:00', '22:20', '22:40', '23:00', '23:20', '23:40']
        this.seriesData = []

        this.nameList.forEach(item => {
          this.seriesData.push({
            name: item.name,
            type: 'line',
            smooth: true,
            data: this.initManyDay(item.item),
            seriesLayoutBy: 'row',
            symbol: 'circle',
            symbolSize: 0,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2.5
                }
              }
            }
          })
        })
        return
      }
      // 合并显示
      this.xData = []
      const dataArr = []
      this.nameList.forEach(item => {
        this.xData.push(...item.item.map(item2 => (item.name).split('-')[1] + '-' + (item.name).split('-')[2] + ' ' + item2.moment))
        dataArr.push(...item.item.map(item2 => item2.value))
      })
      this.seriesData = [{
        name: '',
        type: 'line',
        smooth: true,
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 1,
                color: 'rgba(120,198,255,0.1)'
              },
              {
                offset: 0,
                color: 'rgba(4,150,255,1)'
              }
            ])
          }
        },
        data: dataArr,
        seriesLayoutBy: 'row',
        symbol: 'none',
        symbolSize: 0,
        itemStyle: {
          normal: {
            lineStyle: {
              width: 2.5
            }
          }
        }
      }]
    },
    initManyDay (dataArr) {
      const timeArr = ['00:00', '00:20', '00:40', '01:00', '01:20', '01:40', '02:00', '02:20', '02:40', '03:00', '03:20', '03:40', '04:00', '04:20', '04:40', '05:00', '05:20', '05:40', '06:00', '06:20', '06:40', '07:00', '07:20', '07:40', '08:00', '08:20', '08:40', '09:00', '09:20', '09:40', '10:00', '10:20', '10:40', '11:00', '11:20', '11:40', '12:00', '12:20', '12:40', '13:00', '13:20', '13:40', '14:00', '14:20', '14:40', '15:00', '15:20', '15:40', '16:00', '16:20', '16:40', '17:00', '17:20', '17:40', '18:00', '18:20', '18:40', '19:00', '19:20', '19:40', '20:00', '20:20', '20:40', '21:00', '21:20', '21:40', '22:00', '22:20', '22:40', '23:00', '23:20', '23:40']
      const arr = []
      timeArr.forEach(item => {
        const data = dataArr.find(item2 => item2.moment === item)
        if (data) {
          if (Number(data.value)) {
            arr.push(data.value)
          } else {
            arr.push(null)
          }
        } else {
          arr.push(null)
        }
      })
      return arr
    }
  }
}
</script>

<style lang="stylus">
  .v2-radio-group{
    display:flex;
    justify-content:flex-end;
    margin-right:60px;
    .selecter-one{
      position:absolute;
      top:16%;
      left: 50%;
      transform: translateX(-50%)
      z-index:999;
    }
    .selecter-tow{
      position:absolute;
      top:16%;
      right: 60px;
      z-index:999;
    }
    .el-radio-group{
      border:1px solid rgba(0,119,255,1);
      z-index:999;
      border-radius:4px;
      overflow: visible;
      white-space: nowrap;
    }
    .el-radio-button__inner {
      background: none;
      border:none;
      font-size: 16px;
      color:#999999;
      white-space: nowrap;
      overflow: visible;
    }
    .el-radio-button + .el-radio-button .el-radio-button__inner {
      border-left: 1px solid rgba(0,119,255,1);
    }
    .el-radio-button:first-child .el-radio-button__inner {
      border-left: none;
    }
    .el-radio-button__orig-radio:checked+.el-radio-button__inner{
      background:#0077ff;
      color:white;
    }
    .el-radio-button__inner:hover {
      color: #409EFF;
    }
  }
.v2-waterParameter {
  position: relative;
  .nodata {
    img {
      position: absolute;
      top: 36%;
      left: 44%;
      width: 218px;
      height: 218px;
    }

    span {
      position: absolute;
      top: 70%;
      left: 45.5%;
      color: #6baae6;
      font-size: 20px;
    }
  }

  .el-date-picker {
    .el-date-picker__time-header {
      .el-input--small {
        input {
          color: #626262 !important;
          background: #fff !important;
        }
      }
    }

    .el-button--default {
      width: auto !important;
      background: #fff !important;
      color: #409EFF !important;
    }
    .el-button--primary{
      font-size: 16px;
      width: 120px;
      height 36px;
      color: #fff;
      background:rgba(0,119,255,1);
      border:1px solid rgba(48, 145, 255, 1);
      border-radius:4px;
      margin-right: 15px;
      padding: 10px 30px;

    }

    .el-button--success{
      font-size:16px;
      width: 120px;
      height:36px;
      color: #fff;
      margin-right: 15px;
      // padding: 10px 20px;
      border-radius:4px;
      background:rgba(0,181,115,1);
      border:1px solid rgba(4, 12, 23, 1);
    }

    .input__inner {
    }

    .el-input--small {
      width: auto !important;
    }
  }
  .el-input {
    width: 156px;
    margin-right: 10px;
  }

  .el-input__inner {
    text-align center;
    border: 1px solid #07f;
    color: #fff;
    background: none;
  }

  .el-button--primary {
    margin-left: 30px;
    padding: 10px 0px !important;
    width:120px;
    height:36px;
    font-size 16px;
    background:rgba(0,119,255,1);
    border:1px solid rgba(48, 145, 255, 1);
    border-radius:4px
  }
  .el-button--success{
    width:120px;
    height:36px;
    padding: 10px 0px !important;
    font-size 16px;
    background:rgba(0,181,115,1);
    border:1px solid #23CC8F;
    border-radius:4px
  }
  .demonstration {
    display: inline-block;
    width: 50px;
    margin-left: 10px;
    font-size: 14px;
    text-align: center;
    color: #BBD4E9;
  }

  .spr-line {
    display: inline-block;
    width: 12px;
    text-align: center;
    background: #07f;
    height: 1px;
    line-height: 40px;
    vertical-align: middle;
    margin-right: 10px;
  }
}

</style>
